import React from 'react';
import PropTypes from 'prop-types';
import { StyledHeader, Heading } from './SectionHeaderBar.styles';

const SectionHeaderBar = ({ children }) => (
  <StyledHeader>
    <div>
      <Heading>{React.Children.toArray(children)[0]}</Heading>
    </div>
    <div>
      <Heading>{React.Children.toArray(children)[1]}</Heading>
    </div>
  </StyledHeader>
);

SectionHeaderBar.propTypes = {
  children: PropTypes.node
};

export default SectionHeaderBar;
